
import _ from "lodash";
import { projectTypes } from "constants/projectTypes";
import hedgeTypes from "constants/hedgeTypes";
import { map } from "constants/screenElements/pipelineDealTable";

import {
  formatDisplayValue,
  formatCurrency,
  formatInteger,
  formatRate,
  formatRateThreeDecimal,
  formatMonths,
  formatDate,
  formatDecimalAsInteger,
  formatNumberTwoDecimal,
  notImplemented,
  formatCurrencyTwoDecimal,
  formatDecimalNoDecimal,
  formatNumberOneDecimal
} from "./formattersv2";

const {
  CASH_EQUITY,
  DEBT_MF_UNIT,
  LENDER,
  ALL_IN_RATE,
  LOAN_SPREAD,
  TEAM_MEMBER,
  STATE,
  CITY,
  MF_UNITS,
  SQUARE_FEET,
  ASSET_CLASS,
  ASSET_TYPE,
  OCCUPANCY,
  NOI,
  NOI_ACTUAL,
  BROKER_COMPANY,
  PURCHASE_PRICE,
  APPRAISED_VALUE,
  DESIRED_LOAN_AMOUNT,
  FUND,
  STAGE,
  TARGETED_CLOSE
} = map;

export default {
  [CASH_EQUITY]: formatCurrency,
  [DEBT_MF_UNIT]: formatCurrency,
  [LENDER]: formatDisplayValue,
  [ALL_IN_RATE]: formatRate,
  [LOAN_SPREAD]: formatRateThreeDecimal,
  [TEAM_MEMBER]: notImplemented,
  [STATE]: formatDisplayValue,
  [CITY]: formatDisplayValue,
  [MF_UNITS]: formatDecimalAsInteger,
  [SQUARE_FEET]: formatDecimalAsInteger,
  [ASSET_CLASS]: formatDisplayValue,
  [ASSET_TYPE]: formatDisplayValue,
  [OCCUPANCY]: formatRate,
  [NOI]: formatCurrency,
  [NOI_ACTUAL]: formatCurrency,
  [BROKER_COMPANY]: notImplemented,
  [PURCHASE_PRICE]: formatCurrency,
  [APPRAISED_VALUE]: formatCurrency,
  [DESIRED_LOAN_AMOUNT]: notImplemented,
  [FUND]: notImplemented,
  [STAGE]: notImplemented,
  [TARGETED_CLOSE]: notImplemented
};
